/**
 * 响应式样式工具
 */

import { createStyles } from 'antd-style';
import { BREAKPOINTS } from '../constants/ui';

/**
 * 创建响应式辅助样式
 *
 * 提供在不同断点下显示/隐藏元素的辅助类名。
 *
 * @example
 * ```tsx
 * const useResponsiveStyles = createResponsiveStyles();
 *
 * function MyComponent() {
 *   const { styles } = useResponsiveStyles();
 *   return (
 *     <>
 *       <div className={styles.hiddenOnMobile}>桌面端内容</div>
 *       <div className={styles.visibleOnMobile}>移动端内容</div>
 *     </>
 *   );
 * }
 * ```
 */
export function createResponsiveStyles() {
  return createStyles(({ css, token }) => ({
    /** 移动端隐藏 (宽度 < 768px 时隐藏) */
    hiddenOnMobile: css`
      @media (max-width: ${BREAKPOINTS.md - 1}px) {
        display: none !important;
      }
    `,

    /** 仅移动端可见 (宽度 < 768px 时显示) */
    visibleOnMobile: css`
      @media (min-width: ${BREAKPOINTS.md}px) {
        display: none !important;
      }
    `,

    /** 平板及以下隐藏 (宽度 < 992px 时隐藏) */
    hiddenOnTablet: css`
      @media (max-width: ${BREAKPOINTS.lg - 1}px) {
        display: none !important;
      }
    `,

    /** 仅平板及以下可见 */
    visibleOnTablet: css`
      @media (min-width: ${BREAKPOINTS.lg}px) {
        display: none !important;
      }
    `,

    /** 响应式容器: 移动端全宽，桌面端限制最大宽度 */
    responsiveContainer: css`
      width: 100%;
      max-width: ${BREAKPOINTS.xl}px;
      margin: 0 auto;
      padding: 0 ${token.paddingMD}px;

      @media (max-width: ${BREAKPOINTS.md - 1}px) {
        padding: 0 ${token.paddingSM}px;
      }
    `,

    /** 响应式网格: 移动端单列，平板双列，桌面端三列 */
    responsiveGrid: css`
      display: grid;
      gap: ${token.paddingMD}px;
      grid-template-columns: repeat(3, 1fr);

      @media (max-width: ${BREAKPOINTS.lg - 1}px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: ${BREAKPOINTS.md - 1}px) {
        grid-template-columns: 1fr;
      }
    `,

    /** 响应式 Flex: 移动端垂直，桌面端水平 */
    responsiveFlex: css`
      display: flex;
      gap: ${token.paddingMD}px;

      @media (max-width: ${BREAKPOINTS.md - 1}px) {
        flex-direction: column;
      }
    `,
  }));
}
